import { ModalSize } from "./Modal.types";

export function formatModalSize(size: ModalSize): `${string}px` {
  if (size === "lg") return "800px";

  if (size === "md") return "500px";

  if (size === "sm") return "300px";

  return "500px";
}
